import { ProductionPriceListState } from './state';
import { ProductionPriceListAction, ProductionPriceListActionType } from './actions';

const initialState = require('./initial-data.json') as ProductionPriceListState;
export function ProductionPriceListReducer(state: ProductionPriceListState = initialState, action: ProductionPriceListAction): ProductionPriceListState {
    switch (action.type) {
           case ProductionPriceListActionType.LoadProductionPriceListsAction:
            return {
                ...state,
                formProductionPriceList: action.payload,
            };
            case ProductionPriceListActionType.LoadProductionPriceListAction:
                return {
                    ...state,
                    productionPriceList: action.payload,
                };        
            case ProductionPriceListActionType.ChangeProductionPriceListFilterExpressionAction:
                return {
                    ...state,
                    productionPriceList: null,
                    productionPriceListPaging: { ...state.productionPriceListPaging, page: 1 },
                    productionPriceListFilterExpression: action.payload,
                };
            case ProductionPriceListActionType.ChangeProductionPriceListSortExpressionAction:
                return {
                    ...state,
                    productionPriceList: null,
                    productionPriceListPaging: { ...state.productionPriceListPaging, page: 1 },
                    productionPriceListSortExpression: action.payload,
                };
            case ProductionPriceListActionType.ChangeProductionPriceListPageAction:            
                return {
                    ...state,
                    productionPriceList: null,
                    productionPriceListTotalCount: 0,
                    productionPriceListPaging: { ...state.productionPriceListPaging, page: action.payload },
                };
            case ProductionPriceListActionType.ChangeProductionPriceListTotalCountAction:            
                return {
                    ...state,
                    productionPriceListTotalCount: action.payload.totalCount,                
                };
            case ProductionPriceListActionType.ChangeConditionsShowOnlyValidConditionsAction:
                return{
                    ...state,
                    showOnlyValidConditions: action.payload
                }
            default:
                return state;
        }
}
